/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 用户信息获取接口
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2023-01-10 16:03:16
 * @LastEditTime: 2023-01-10 16:08:24
 * @FilePath: /client-h5-v2/src/apis/login/userInfoADFS.ts
 */

// 导入axios实例
import httpRequest from '@/request/index'
import { LoginAuthParams } from '@/apis/types'
import { apiGetLocalfiles } from '@/apis/config/applicationPropterty'

// 获取用户信息
export function apiGetUserInfoADFS (param: LoginAuthParams) {
  if (window.botV2GlobalProperties.NODE_ENV === 'development') {
    return apiGetLocalfiles(`/${window.botV2GlobalProperties.BASE_PATH}/json/businessResult/loginADFS.json`)
  } else {
    return httpRequest({
      url: '/api/v1/loginAuth',
      method: 'post',
      data: param
    })
  }
}
